module.exports = __webpack_public_path__ + "img/meta-trader4.b4996b21.png";